export default function Home() {
  return <h1>reports page</h1>;
}